/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type {
  PostUsersIdRestoreMutationResponse,
  PostUsersIdRestorePathParams,
  PostUsersIdRestore400,
  PostUsersIdRestore403,
} from '../entities/PostUsersIdRestore'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'

function getPostUsersIdRestoreUrl(id: PostUsersIdRestorePathParams['id']) {
  return `/users/${id}/restore` as const
}

/**
 * @description Восстановление пользователя админом компании
 * @summary Восстановление пользователя
 * {@link /users/:id/restore}
 */
export async function postUsersIdRestore(id: PostUsersIdRestorePathParams['id'], config: Partial<RequestConfig> & { client?: typeof client } = {}) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<PostUsersIdRestoreMutationResponse, ResponseErrorConfig<PostUsersIdRestore400 | PostUsersIdRestore403>, unknown>({
    method: 'POST',
    url: getPostUsersIdRestoreUrl(id).toString(),
    ...requestConfig,
  })
  return res.data
}